import { render, staticRenderFns } from "./KeywordReply.vue?vue&type=template&id=126ea434&scoped=true"
import script from "./KeywordReply.vue?vue&type=script&lang=js"
export * from "./KeywordReply.vue?vue&type=script&lang=js"
import style0 from "./KeywordReply.vue?vue&type=style&index=0&id=126ea434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ea434",
  null
  
)

export default component.exports